import React from 'react';

const CaregiversPrivacyActStatement = () => (
  <>
    <p>
      <strong>The Paperwork Reduction Act:</strong> This information collection
      is in accordance with the clearance requirements of section 3507 of the
      Paperwork Reduction Act of 1995. Public reporting burden for this
      collection of information is estimated to average 15 minutes per response,
      including the time to read instructions, gather necessary data, and fill
      out the form. Respondents should be aware that notwithstanding any other
      provision of law, no person shall be subject to any penalty for failing to
      comply with a collection of information if it does not display a currently
      valid OMB control number. Completion of this form is mandatory for
      individuals who wish to participate in the Program of Comprehensive
      Assistance for Family Caregivers.
    </p>
    <p>
      <strong>Privacy Act information:</strong> VA is asking you to provide the
      information on this form under 38 U.S.C. Sections 101, 5303A, 1705, 1710,
      1720B, 1720G, 1725 and 1781 in order for VA to determine your eligibility
      for medical benefits. Information you supply may be verified through a
      computer-matching program. VA may disclose the information that you put on
      the form as permitted by law. VA may make a "routine use" disclosure of
      the information as outlined in the Privacy Act systems of records,
      “Patient Medical Records --VA” (24VA10P2), “Enrollment and Eligibility
      Records --VA” (147VA10NF1), and “Veterans and Beneficiaries Purchased Care
      Community Healthcare Claims, Correspondence, Eligibility, Inquiry and
      Payment Files - VA” (54VA10NB3) and in accordance with the VHA Notice of
      Privacy Practices. Providing the requested information, including Social
      Security Number, is voluntary, but if any or all of the requested
      information is not provided, it may delay or result in denial of your
      request for healthcare benefits. Failure to furnish the information will
      not have any effect on any other benefits to which you may be entitled. If
      you provide VA your Social Security Number, VA will use it to administer
      your VA benefits. VA may also use this information to identify Veterans
      and persons claiming or receiving VA benefits, and their records, and for
      other purposes authorized or required by law.
    </p>
  </>
);

export default CaregiversPrivacyActStatement;
